import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/edit.svg'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row items-center py-2 container"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-200" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "py-8 flex flex-row items-center lg:container lg:p-0 p-2 w-full"
}
const _hoisted_7 = { class: "flex flex-row lg:ml-4 bg-white w-full" }
const _hoisted_8 = { class: "w-full lg:px-7" }
const _hoisted_9 = { class: "flex lg:flex-row flex-col items-center lg:justify-between w-full justify-center" }
const _hoisted_10 = { class: "text-2xl sm:mb-6" }
const _hoisted_11 = { class: "flex flex-col lg:flex-row md:flex-row items-center" }
const _hoisted_12 = { class: "flex flex-col lg:flex-row md:flex-row items-center pr-5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Job activity", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "View job page", -1)
const _hoisted_15 = { class: "flex-grow bg-background shadow-inner min-h-screen" }
const _hoisted_16 = { class: "container lg:py-8 p-3 h-full" }
const _hoisted_17 = { class: "sm:flex md:flex-col flex-row lg:space-x-5 space-y-6 sm:space-y-0 lg:flex-row" }
const _hoisted_18 = { class: "sm:w-full lg:w-4/12 justify-between items-start space-y-3" }
const _hoisted_19 = { class: "card-main w-full" }
const _hoisted_20 = { class: "flex flex-row justify-between" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold" }, "Code challenge", -1)
const _hoisted_22 = { class: "flex flex-col relative" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "7",
    r: "2",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "12",
    cy: "17",
    r: "2",
    fill: "black"
  })
], -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "absolute border-gray-100 right-0 top-auto mt-5 w-60 rounded-xl shadow-2xl text-sm overflow-hidden z-20"
}
const _hoisted_26 = {
  class: "rounded-md bg-white shadow-xs w-full px-2 py-1",
  role: "menu",
  "aria-orientation": "vertical",
  "aria-labelledby": "options-menu"
}
const _hoisted_27 = { class: "flex flex-col mt-4" }
const _hoisted_28 = { class: "flex flex-row items-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_30 = { class: "font-semibold ml-4" }
const _hoisted_31 = { class: "flex flex-row w-full justify-between pt-2 items-center" }
const _hoisted_32 = { class: "flex flex-col" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "text-xs text-gray-400" }, "Challenge title", -1)
const _hoisted_34 = { class: "text-xs text-primary" }
const _hoisted_35 = ["href"]
const _hoisted_36 = { class: "card-main" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row w-full space-x-3 items-center justify-between pb-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold" }, "Candidates")
], -1)
const _hoisted_38 = { class: "flex flex-row justify-end w-full pb-3 items-center" }
const _hoisted_39 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_40 = { class: "w-30" }
const _hoisted_41 = { class: "flex flex-row w-full py-3" }
const _hoisted_42 = {
  key: 0,
  class: "bg-primary-light px-2 py-2 font-bold text-xs w-full rounded"
}
const _hoisted_43 = {
  key: 1,
  class: "overflow-y-scroll",
  style: {"max-height":"600px"}
}
const _hoisted_44 = { key: 2 }
const _hoisted_45 = { class: "w-full mt-3 lg:mt-0 lg:w-8/12 md:mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_StageBar = _resolveComponent("StageBar")!
  const _component_SimpleSelect = _resolveComponent("SimpleSelect")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_JobCandidateCard = _resolveComponent("JobCandidateCard")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_JobMembersSection = _resolveComponent("JobMembersSection")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AddCandidatesForm = _resolveComponent("AddCandidatesForm")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!
  const _component_DeleteCandidate = _resolveComponent("DeleteCandidate")!
  const _component_AddCandidatesInJob = _resolveComponent("AddCandidatesInJob")!
  const _component_AddTemplateToJob = _resolveComponent("AddTemplateToJob")!
  const _component_AddChallengeToJob = _resolveComponent("AddChallengeToJob")!
  const _component_ModalUpgradePlan = _resolveComponent("ModalUpgradePlan")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Header),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Loading, {
              active: _ctx.isLoading,
              "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
              "can-cancel": false,
              loader: "spinner",
              color: "#8908F9",
              width: 128,
              height: 128,
              opacity: 0.5,
              "is-full-page": true
            }, null, 8, ["active", "opacity"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.jobStore.title), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_router_link, {
                        type: "button",
                        to: `/jobs/${_ctx.route.params.id}/events`,
                        class: "text-primary bg-white px-4 py-2 hover:bg-gray-100"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createVNode(_component_router_link, {
                        type: "button",
                        to: `/jobs/${_ctx.route.params.id}/details`,
                        class: "text-primary bg-white px-4 py-2 hover:bg-gray-100"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createVNode(_component_Button, {
                        variant: "",
                        label: "Edit job",
                        onOnClick: _ctx.EditJob
                      }, null, 8, ["onOnClick"]),
                      _createVNode(_component_Button, {
                        variant: "",
                        label: "Search candidates",
                        onOnClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/candidates`)))
                      })
                    ]),
                    _createVNode(_component_Button, {
                      variant: "outlined",
                      label: "Add candidates",
                      onOnClick: _ctx.createCandidate
                    }, null, 8, ["onOnClick"])
                  ])
                ]),
                _createVNode(_component_StageBar, {
                  stages: _ctx.jobStore?.job_stages,
                  totalCandidates: _ctx.jobStore?.number_candidates
                }, null, 8, ["stages", "totalCandidates"])
              ])
            ])
          ])),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("button", {
                      class: "p-1 hover:bg-gray-100 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (
											_ctx.isMenuOpenChallenge =
												!_ctx.isMenuOpenChallenge
										))
                    }, _hoisted_24),
                    (_ctx.isMenuOpenChallenge)
                      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createTextVNode(_toDisplayString(_ctx.job) + " ", 1),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("button", {
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateChallenge && _ctx.updateChallenge(...args))),
                                class: "rounded p-4 hover:bg-background"
                              }, [
                                _createElementVNode("div", _hoisted_28, [
                                  _hoisted_29,
                                  _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.jobStore
																	?.job_challenge
																	?.id
																	? 'Update challenge'
																	: 'Add challenge'), 1)
                                ])
                              ])
                            ])
                          ])
                        ], 512)), [
                          [_directive_click_away, _ctx.closeMenuChallenge]
                        ])
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createElementVNode("span", {
                      class: _normalizeClass(["font-semibold", [
											_ctx.jobStore?.job_challenge?.title
												? 'text-primary'
												: '',
										]])
                    }, _toDisplayString(_ctx.jobStore?.job_challenge?.title
												? _ctx.jobStore?.job_challenge?.title
												: 'Unassigned code challenge'), 3),
                    _createElementVNode("span", _hoisted_34, [
                      _createElementVNode("a", {
                        href: 
												_ctx.jobStore.job_challenge
													?.challenge_url
											
                      }, _toDisplayString(_ctx.jobStore.job_challenge
													?.challenge_url
													? _ctx.jobStore.job_challenge
															?.challenge_url
													: 'no specified'), 9, _hoisted_35)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createVNode(_component_SimpleSelect, {
                        modelValue: _ctx.stage,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.stage) = $event)),
                        className: "text-xs",
                        label: "Filter by stages",
                        options: _ctx.selectStages
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.stage = '')),
                      class: "hover:text-primary-dark text-xs hover:bg-gray-100 text-primary"
                    }, " All Stages ")
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _createVNode(_component_SearchInput, {
                    modelValue: _ctx.inputValue,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inputValue) = $event)),
                    onOnSubmit: _ctx.getData,
                    placeholder: "Search for candidates...."
                  }, null, 8, ["modelValue", "onOnSubmit"])
                ]),
                (_ctx.candidates && _ctx.candidates.length <= 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, " No candidates assigned in this stage "))
                  : _createCommentVNode("", true),
                (!_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidates &&
									_ctx.candidates.length > 0 &&
									_ctx.candidates, (item, index) => {
                        return (_openBlock(), _createBlock(_component_JobCandidateCard, {
                          key: `card-candidate-${index + 1}`,
                          selected: _ctx.selected,
                          candidate: item,
                          onClickCard: ($event: any) => (_ctx.handleCandidateClick(item.id))
                        }, null, 8, ["selected", "candidate", "onClickCard"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2], (item, index) => {
                        return _createVNode(_component_Skeleton, {
                          option: "candidates",
                          key: index
                        })
                      }), 64))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_JobMembersSection, { jobId: _ctx.jobId }, null, 8, ["jobId"])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createVNode(_component_router_view)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModal,
      onClose: _ctx.closeInForm
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddCandidatesForm, {
          ref: "formRef",
          onCloseModal: _ctx.closeInForm,
          onGetCandidates: _ctx.getFromForm
        }, null, 8, ["onCloseModal", "onGetCandidates"])
      ]),
      _: 1
    }, 8, ["show", "onClose"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showDelete,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showDelete = false)),
      size: "w-1/3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DeleteCandidate, {
          onCloseModal: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDelete = false)),
          onGetCandidates: _ctx.getFromForm,
          candidateId: _ctx.userInfo.id
        }, null, 8, ["onGetCandidates", "candidateId"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showSearch,
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setShowSearch(false))),
      size: "w-1/2 bg-background min-h-screen"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddCandidatesInJob, { onGetCandidates: _ctx.getFromForm }, null, 8, ["onGetCandidates"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModalEval,
      onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setShowModalEval(false))),
      size: "w-1/3 bg-background min-h-screen"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddTemplateToJob, {
          id: _ctx.jobStore.id,
          onReload: _ctx.updateJobInfo,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setShowModalEval(false)))
        }, null, 8, ["id", "onReload"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showChallenge,
      onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setShowChallenge(false))),
      size: "w-1/3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddChallengeToJob, {
          id: _ctx.jobStore.id,
          onReload: _ctx.updateJobInfo,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setShowChallenge(false)))
        }, null, 8, ["id", "onReload"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModalUpgrade,
      onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showModalUpgrade = false)),
      size: "lg:w-1/3 md:w-9/12 w-11/12"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalUpgradePlan, {
          onCloseModal: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showModalUpgrade = false))
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}